export default "__VITE_ASSET__DGvGUPJ2__"